import React from "react";
import { MdSearchOff } from "react-icons/md";
import { useSelector } from "react-redux";

import Modal from "../modal/Modal";
import { Search } from "../search/Search";
import { EmptyState } from "../emptyState/EmptyState";
import { useCityModal } from "./useCityModal";
import { selectCity } from "../../../store/slices/citySlice";
import styles from "./CityModal.module.scss";

interface CityModalProps {
  isVisible: boolean;
}

export const CityModal: React.FC<CityModalProps> = ({ isVisible }) => {
  const currentCity = useSelector(selectCity);
  const {
    cities,
    loading,
    query,
    setQuery,
    clearSearch,
    selectCity: onSelect,
    closeModal,
    hasSelectedCity,
  } = useCityModal();

  return (
    <Modal
      isVisible={isVisible}
      onClose={closeModal}
      variant="bottom"
      closeOnBackdrop={hasSelectedCity}
      closeOnEsc={hasSelectedCity}
    >
      <div className={styles.Container}>
        <h2 className={styles.Title}>Выберите город</h2>

        <div className={styles.SearchWrap}>
          <Search
            value={query}
            onChange={setQuery}
            clear={clearSearch}
            placeHolder="Поиск города..."
          />
        </div>

        <div className={styles.List}>
          {loading && <div className={styles.Hint}>Загрузка...</div>}

          {!loading && cities.length === 0 && (
            <div className={styles.EmptyWrap}>
              <EmptyState
                icon={MdSearchOff}
                title="Города не найдены"
                description="Попробуйте другой запрос."
              />
            </div>
          )}

          {!loading &&
            cities.map((c) => (
              <button
                key={c.id}
                type="button"
                data-city-id={c.id}
                className={styles.Row}
                data-active={currentCity?.id === c.id || undefined}
                onClick={() => onSelect(c)}
              >
                <span className={styles.RowBgName} aria-hidden="true">
                  {c.value}
                </span>
                <span className={styles.RowName}>{c.value}</span>
              </button>
            ))}
        </div>
      </div>
    </Modal>
  );
};